import { GridColDef } from '@mui/x-data-grid';

/**
 * Shared utility functions and column definitions for Quality pages
 */

// Format date for display in table cells
export const formatDateTime = (dateString: string | null): string => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return `${date.toLocaleDateString('fr-FR')} ${date.toLocaleTimeString('fr-FR')}`;
};

// Common article columns that are used in both LotPage and Articles tab
export const getArticleColumnDef = (): GridColDef[] => [
    {
        field: 'checkPointArticleRef',
        headerName: 'Référence',
        width: 220,
    },
    {
        field: 'storeLabel',
        headerName: 'Boutique',
        width: 150,
    },
    {
        field: 'warehouseAt',
        headerName: 'Plateforme',
        valueFormatter: (params) => formatDateTime(params.value as string),
        width: 160,
    },
    {
        field: 'shippingAt',
        headerName: 'Transport',
        valueFormatter: (params) => formatDateTime(params.value as string),
        width: 160,
    },
    {
        field: 'boutiqueAt',
        headerName: 'Boutique',
        valueFormatter: (params) => formatDateTime(params.value as string),
        width: 160,
    },
    {
        field: 'soldAt',
        headerName: 'Vendu',
        valueFormatter: (params) => formatDateTime(params.value as string),
        width: 160,
    },
    {
        field: 'stolenAt',
        headerName: 'Volé',
        valueFormatter: (params) => formatDateTime(params.value as string),
        width: 160,
    },
    {
        field: 'destroyedAt',
        headerName: 'Détruit',
        valueFormatter: (params) => formatDateTime(params.value as string),
        width: 160,
    },
];
